<div class="relative">
  <button
    class="transition-color flex w-full items-center justify-center border-1 border-dashed border-black bg-po-gray-50 bg-opacity-40 py-5 duration-300 ease-in-out"
    awRipple
    awFileUploadDrop
    [ngClass]="{
      'cursor-not-allowed border-opacity-40 opacity-40': disabled,
      'cursor-pointer hover:bg-po-gray-100': !disabled
    }"
    data-testid="fileUploadTriggerBtn"
    defaultBgClass="bg-po-gray-50"
    hoveredBgClass="bg-po-gray-100"
    type="button"
    [disabled]="disabled"
    [rippleDisabled]="disabled"
    [dropDisabled]="disabled"
    (filesDropped)="onFilesDropped($event)"
    (click)="onOpenFileBrowser($event)"
  >
    <label [attr.for]="id | awId: 'input'">
      <ng-content />
    </label>
  </button>

  <input
    #input
    class="pointer-events-none absolute left-0 top-0 h-0 w-0"
    data-testid="fileInput"
    data-testid="fileUploadInput"
    style="display: none !important"
    type="file"
    [attr.id]="id | awId: 'input'"
    [attr.accept]="acceptAttr"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="onFilesAttached($event)"
  />
</div>
